
import { Component, Vue } from "vue-property-decorator";
import MenuLateral from "./MenuLateral.vue";

@Component({
  components: {
    MenuLateral
  },
})
export default class Cabecalho extends Vue {
  menuMobileVisible = false;
  
  async logout() {
    this.$emit("logout");
  }
  
  toggleMenu() {
    this.menuMobileVisible = !this.menuMobileVisible;
    document.body.classList.toggle('menu-open', this.menuMobileVisible);
  }
}
